<!-- @format -->

<div
	class="background-base-subtle hmf-display-flex hmf-justify-content-center hmf-py-m-xl"
	[ngClass]="{
		'background-image': chain?.chainIdentifierAbbr === 'pl' && backgroundImage(),
		'descriptiveH2 hmf-py-s-m hmf-px-s-s': descriptiveH2Enabled()
	}"
	[ngStyle]="{ 'background-image': backgroundImage() }">
	<div class="pdp-content-width hmf-p-m-xl background-base border-subtle">
		@if (descriptiveH2Enabled()) {
			<div
				class="hmf-display-flex hmf-flex-column hmf-align-items-center hmf-mb-m hmf-mt-s-m hmf-mt-m-auto hmf-mb-s-s hmf-g-xxs">
				<div class="hmf-header-bold-s-s hmf-header-bold-m-m hmf-text-align-center">
					{{ sectionTitle() }}
				</div>
				@if (descriptiveH2Text()) {
					<h2
						class="hmf-body-s hmf-body-md-m hmf-px-s-xs hmf-mt-s-xxs hmf-mt-m-auto hmf-text-align-center">
						{{ descriptiveH2Text() }}
					</h2>
				}
			</div>
		} @else {
			<div
				class="hmf-display-none hmf-display-m-block hmf-header-bold-l hmf-text-align-center hmf-mb-m">
				{{ sectionTitle() }}
			</div>
		}
		<div data-testid="product-info-specs">
			<ng-content></ng-content>
		</div>
	</div>
</div>
